"use client";

import React from 'react';

interface QuestionChoiceProps {
  number: number;
  text: string;
  onClick: (number: number) => void;
  isSelected?: boolean;
}

const QuestionChoice: React.FC<QuestionChoiceProps> = ({ number, text, onClick, isSelected }) => {
  return (
    <div
      className={`
        flex flex-row px-2 py-4 border rounded-lg cursor-pointer group select-none
        ${isSelected ? 'bg-purple-500 text-white' : 'bg-gray-100 dark:bg-dark-600 text-gray-800 dark:text-white border-transparent'}
        md:hover:border-purple-500 border border-gray-300
      `}
      onClick={() => onClick(number)}
    >
      <div className={`${isSelected? 'border-white' :'border-gray-800 dark:border-white md:group-hover:border-purple-500'} h-[25px] w-[25px] text-center border rounded-[4px] `}>
        {number}
      </div>
      <div className='ms-3'>
        {text}
      </div>
    </div>
  );
};

export default QuestionChoice;